import React, { useContext, useState } from "react";
import ButtonSubmit from "../ButtonSubmit";
import { isValidGender, simplyClick } from "../../helpers";
import "./GenderForm.scss";
import { ContextProfileUser } from "../../lib/profileContext";
import { genderLabel, CONST_GENDER_MALE, genderKey } from "../../constants";
import ProgressDots from "../ProgressDots/ProgressDots";

const GenderForm = ({ nextStep }) => {
  const [errorGender, setErrorGender] = useState(null);
  const { data, setData } = useContext(ContextProfileUser);
  const [choiceGender, setChoiceGender] = useState(CONST_GENDER_MALE);
  const [genderWasChanged, setGenderWasChanged] = useState(false);

  const handlerSubmit = (e) => {
    e.preventDefault();

    if (!isValidGender(data.gender)) {
      setErrorGender("Please, choose your gender");
    } else {
      if (!genderWasChanged) {
        simplyClick("cl_lnd_i_am_st2_gender", {
          text: genderKey[data.gender || choiceGender],
        });
      }
      simplyClick("cl_lnd_i_am_st2_action", { text: "next" });
      nextStep();
    }
  };

  const handleAddTypeGender = ({ target: { value } }) => {
    const genderValue = Number(value);
    setData({ ...data, gender: genderValue });
    setChoiceGender(genderValue);
    setGenderWasChanged(true);

    simplyClick("cl_lnd_i_am_st2_gender", {
      text: genderKey[genderValue],
    });
  };

  const options = Object.keys(genderLabel).map((key, index) => (
    <option value={key} key={`${key}_${index}`}>
      {genderLabel[key]}
    </option>
  ));

  return (
    <div className="promo__wrapper-gender">
      <form className="gender__form" onSubmit={handlerSubmit}>
        <div className="user__form-top">
          <h3>I am a</h3>
        </div>
        <div className="gender__form-content">
          <div className="custom-select gender">
            <div className="custom-select-me">
              <select
                onChange={handleAddTypeGender}
                className="gender"
                value={choiceGender}
              >
                {options}
              </select>
            </div>
          </div>
          {errorGender && <p className="error">{errorGender}</p>}
          <ButtonSubmit
            className={"button__global button__gender"}
            text={"NEXT"}
            data-cokies="cookies"
          />
          <ProgressDots total={12} activeCount={2} />
        </div>
      </form>
    </div>
  );
};

export default GenderForm;
